<nav>
	<app-site-header
		[fireNewsletterPopUp]="fireNewsletterPopUp"
		[showScore]="showScore"
	></app-site-header>
	<app-sport-scrollbar *ngIf="onHomePage()"></app-sport-scrollbar>
</nav>
<main>
	<router-outlet></router-outlet>
</main>
<!-- <div class="update-prompt" [class.on-screen]="updatePromptVisible" (click)="reloadPage()">
	<div class="update-copy">
		New Data Available
	</div>
	<div class="update-button">
		<fa-icon [icon]="faRedoAlt" aria-hidden="true"></fa-icon>
		Reload
	</div>
</div> -->
<app-site-footer
	[fireNewsletterPopUp]="fireNewsletterPopUp"
	[showPartner]="showPartner"
></app-site-footer>
<app-subscribe-click-prompt
	*ngIf="environment.optionalFeatures.includes('newsletter')"
	[visible]="newsletterPopUpVisible"
	[hideCallback]="hideNewsletterPopUp"
></app-subscribe-click-prompt>
<app-subscribe-scroll-prompt *ngIf="environment.optionalFeatures.includes('newsletter') && environment.newsletterProvider === 'surge'"></app-subscribe-scroll-prompt>
<app-exit-prompt *ngIf="environment.optionalFeatures.includes('newsletter') && environment.newsletterProvider === 'surge'"></app-exit-prompt>
